import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _VideoLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M16.211 11.106 9.737 7.868A1.2 1.2 0 0 0 8 8.942v6.116a1.2 1.2 0 0 0 1.737 1.074l6.474-3.238a1 1 0 0 0 0-1.788" }),
            React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor" })));
}
const VideoLight = forwardRef(_VideoLight);
export { VideoLight };
